module.exports = __webpack_public_path__ + "img/Section_land.c195daff.png";